import { Color, SimpleMarkdown } from '@elearning-platform/ui';
import { styled } from 'styled-components';

export const Container = styled.div``;

export const Disclaimer = styled.div`
  background-color: ${Color.White};
  padding: 20px;
`;

export const Paragraphs = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px;
  margin: 20px 0;
`;

export const ParagraphWrapper = styled.div``;

export const ParagraphTitle = styled(SimpleMarkdown)`
  strong {
    color: ${Color.Brand300};
  }
`;
